import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course04 from "../../../course/course-04/course";
import lesson0419 from "../../../lesson/course-04/lesson-19/lesson";
import lesson0424 from "../../../lesson/course-04/lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "87df4b52-9fe6-4019-a640-5f37c6411cd0",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
  {
    id: "4cb24272-489c-4a41-8583-4cefc317b58d",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0424),
    lesson: lesson0424,
  },
];

export default lessonLinks;
